import { Injectable } from '@angular/core';
import { ApplicationHttpService } from '../../core/services/application-http.service';
import { Observable } from 'rxjs';

export interface SessionInfo {
  is_first_login: boolean;
}

/**
 * Session info from api-int (e.g. first login flag for welcome notification).
 */
@Injectable({ providedIn: 'root' })
export class SessionService {

  constructor(private http: ApplicationHttpService) {}

  getSession(): Observable<SessionInfo> {
    return this.http.get<SessionInfo>('session');
  }
}
